import * as React from "react";
import classNames from "classnames";
import { genBlock } from "@/utils/bem";
import "./style.less";

interface tabCard {
  title: string;
  desc: string;
  icon: string;
  img: string;
}

interface TabCardsProps {
  title?: string;
  list?: tabCard[];
  className?: string;
  style?: React.CSSProperties;
}

const block = genBlock("wx-tab-cards");

/**
 * @example
  title?: string;
  list?: tabCard[]
  // tabCard
  title: string;
  desc: string;
  icon: string;
  img: string;
 */
export const TabCards: React.FC<TabCardsProps> = ({
  title,
  list = [],
  className = "",
  style = {},
}) => {
  const isStopRef = React.useRef(false);
  const [tabIndex, setTabIndex] = React.useState(0);

  React.useEffect(() => {
    const intervarId = setInterval(() => {
      if (isStopRef.current) return;
      setTabIndex((state) => (state >= list.length - 1 ? 0 : state + 1));
    }, 3000);

    return () => {
      clearInterval(intervarId);
    };
  }, []);

  const handleTabIndex = (index) => {
    isStopRef.current = true;
    setTabIndex(index);
  };

  const handleLeave = () => {
    isStopRef.current = false;
  };

  return (
    <div className={classNames(block(), className)} style={style}>
      <div className={block("title")}>{title}</div>
      <div className={block("pc-wrap")}>
        <div className={block("tab-list")}>
          {list.map((item, index) => (
            <div
              className={classNames(block("pc-item"), {
                active: tabIndex === index,
              })}
              onMouseOver={() => handleTabIndex(index)}
              onMouseLeave={() => handleLeave()}
            >
              <img src={item.icon} alt="" className={block("pc-item-icon")} />
              <div className={block("pc-item-info")}>
                <p className={block("pc-item-title")}>{item.title}</p>
                <p className={block("pc-item-desc")}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className={block("tab-img-wrap")}>
          {list.map((item, index) => (
            <img
              src={item.img}
              alt=""
              className={`${block("tab-img")} ${
                tabIndex === index ? "show" : ""
              }`}
            />
          ))}
        </div>
      </div>
      <div className={block("wap-wrap")}>
        {list.map((item) => (
          <div className={block("wap-item")}>
            <div className={block("wap-item-title")}>
              <img src={item.icon} alt="" className={block("wap-item-icon")} />
              <div className={block("wap-item-info")}>
                <p className={block("wap-item-text")}>{item.title}</p>
                <p className={block("wap-item-desc")}>{item.desc}</p>
              </div>
            </div>
            {/* <img src={item.img} alt="" className={block("wap-item-img")} /> */}
          </div>
        ))}
      </div>
    </div>
  );
};
